<template>
  <div class="confirmOrderBox">
    <div class="confirmOrderBox-header">
      <div class="clearfix">
        <div class="div_left">
          <span class="logo"></span>
          <span style="margin-left: 10px">{{ $t("common.title") }}</span>
        </div>
        <div class="div_select_right">
          <el-select
            v-model="languagekey"
            placeholder="Select"
            size="large"
            style="width: 240px"
            @change="changeL(languagekey)"
          >
            <el-option
              v-for="item in language"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
    </div>
    <div class="confirmOrderBox-center">
      <div class="topStatus">
        <div class="top clearfix">
          <div class="div_left">
            <span class="statusIcon">
              <img src="../../assets/pc/wait_orange.svg" alt />
            </span>
            <span class="statusText">{{ $t("pc.confirmOrderInfo") }}</span>
          </div>
          <div class="div_right">
            <span style="font-size:16px;color:rgba(102,102,102,1);">
              {{ $t("pc.payTotel1") }}
            </span>
            <span
              style="font-size:24px;line-height:24px;font-weight:600;color:rgba(255,121,40,1);margin-left:16px"
            >
              <span style="font-size: 16px;margin-top: -3px;">
                {{ goodInfo.currencySymbol }}
              </span>
              {{ goodInfo.totalFee }}
            </span>
          </div>
        </div>
      </div>
      <div class="botGoods">
        <div class="part clearfix">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 175px'
                : 'width: 64px'
            "
          >
            {{ $t("pc.goodsNo") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:900px'
                : this.$i18n.locale === 'fr'
                ? 'width: 900px'
                : 'width: 1012px'
            "
          >
            {{ goodInfo.merchantOrderNo }}
          </span>
        </div>
        <div class="part clearfix">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 175px'
                : 'width: 64px'
            "
          >
            {{ $t("pc.goodsName") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:900px'
                : this.$i18n.locale === 'fr'
                ? 'width: 900px'
                : 'width: 1012px'
            "
          >
            {{ goodInfo.goodsName }}
          </span>
        </div>
        <div class="part clearfix" style="margin-bottom: 0">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 175px'
                : 'width: 64px'
            "
          >
            {{ $t("pc.goodsDes") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:900px'
                : this.$i18n.locale === 'fr'
                ? 'width: 900px'
                : 'width: 1012px'
            "
          >
            {{ goodInfo.goodsDetail }}
          </span>
        </div>
      </div>
    </div>
    <div class="confirmOrderBox-footer">
      <div class="resultIcon">
        <img src="../../assets/pc/confirm_pc.gif" alt />
      </div>
      <div class="resultText">{{ $t("pc.confirmText") }}</div>
    </div>
  </div>
</template>
<script>
import "@/style/pc/reset.css";
import api from "@/api/api";
export default {
  name: "confirm",
  data() {
    return {
      language: [
        { text: "English", value: "0" },
        { text: "简体中文", value: "1" },
        { text: "Français", value: "2" },
        { text: "日本語", value: "3" },
        { text: "한국어", value: "4" }
      ],
      languageTitle: "English",
      languagekey: "0",
      goodInfo: {
        currencySymbol: "",
        totalFee: "",
        merchantOrderNo: "",
        goodsName: "",
        goodsDetail: ""
      },
      merchantPayNo: "",
      checkoutToken: "",
      businessCode: "",
      payTradeNo: "",
      clearTime: null,
      timeOut: 0
    };
  },
  methods: {
    /**
     * @method changeL
     * @param {string} title 语种
     * @description 语言切换
     */
    changeL(title) {
      // console.log(title);
      // title === "中文"
      //   ? (this.$i18n.locale = "zh")
      //   : (this.$i18n.locale = "en");
      // title === "中文"
      //   ? (this.languageTitle = "English")
      //   : (this.languageTitle = "中文");
      // title === "中文"
      //   ? localStorage.setItem("lang", "zh")
      //   : localStorage.setItem("lang", "en");
      switch (title) {
        case "0":
          this.$i18n.locale = "en";
          this.languageTitle = "English";
          localStorage.setItem("lang", "en");
          break;
        case "1":
          this.$i18n.locale = "zh";
          this.languageTitle = "简体中文";
          localStorage.setItem("lang", "zh");
          break;
        case "2":
          this.$i18n.locale = "fr";
          this.languageTitle = "Français";
          localStorage.setItem("lang", "fr");
          break;
        case "3":
          this.$i18n.locale = "ja";
          this.languageTitle = "日本語";
          localStorage.setItem("lang", "ja");
          break;
        case "4":
          this.$i18n.locale = "ko";
          this.languageTitle = "한국어";
          localStorage.setItem("lang", "ko");
          break;
      }
    },
    /**
     * @method verifyPage
     * @description 捕获接口
     */
    verifyPage() {
      if (this.timeOut === 300) {
        clearInterval(this.clearTime);
        return false;
      }
      api.apiMethod.verifyPage
        .post(
          {
            merchantPayNo: this.merchantPayNo,
            businessCode: this.businessCode,
            payTradeNo: this.payTradeNo
          },
          {
            checkoutToken: this.checkoutToken
          }
        )
        .then(res => {
          if (res.data.code === 10000) {
            if (res.data.data.status === 1) {
              clearInterval(this.clearTime);
              window.location.href = res.data.data.returnUrl;
            }
          }
        });
    },
    /**
     * @method confirmGetInfo
     * @description 获取商品信息
     */
    confirmGetInfo() {
      api.apiMethod.showNoAuthon
        .post(
          {
            merchantPayNo: this.merchantPayNo,
            businessCode: this.businessCode
          },
          {
            checkoutToken: this.checkoutToken
          }
        )
        .then(res => {
          if (res.data.code === 10000) {
            this.goodInfo = {
              ...res.data.data
            };
            this.clearTime = setInterval(() => {
              this.timeOut += 2;
              this.verifyPage();
            }, 2000);
          }
        });
    },
    /**
     * @method init
     * @description 初始化页面
     */
    init() {
      if (this.$i18n.locale === "en") {
        this.languageTitle = "English";
        this.$i18n.locale = "en";
        this.languagekey = "0";
      } else if (this.$i18n.locale === "zh") {
        this.languageTitle = "简体中文";
        this.$i18n.locale = "zh";
        this.languagekey = "1";
      } else if (this.$i18n.locale === "fr") {
        this.languageTitle = "Français";
        this.$i18n.locale = "fr";
        this.languagekey = "2";
      } else if (this.$i18n.locale === "ja") {
        this.languageTitle = "日本語";
        this.$i18n.locale = "ja";
        this.languagekey = "3";
      } else if (this.$i18n.locale === "ko") {
        this.languageTitle = "한국어";
        this.$i18n.locale = "ko";
        this.languagekey = "4";
      }
      this.checkoutToken = this.$route.query.checkoutToken;
      this.merchantPayNo = this.$route.query.merchantPayNo;
      this.businessCode = this.$route.query.businessCode;
      this.payTradeNo = this.$route.query.payTradeNo;
      this.confirmGetInfo();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.confirmOrderBox {
  width: 100%;
  height: 100%;
  .confirmOrderBox-header {
    width: 100%;
    height: 100px;
    background-color: #fff;
    border-bottom: 4px solid #ffaa0a;
    & > div {
      width: 1180px;
      height: 48px;
      padding: 26px 0;
      margin: 0 auto;
      span {
        vertical-align: middle;
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
      .logo {
        width: 48px;
        height: 48px;
        display: inline-block;
        background: url("../../assets/pc/logo_Cashier@2x.png") no-repeat;
        background-size: 48px;
      }
      .div_select_right {
        float: right;
        margin-top: 5px;
        .el-select {
          width: 160px !important;
          .el-input {
            border-radius: 8px;
            .el-input__inner {
              border-radius: 8px;
              // border: 1px solid #ffaa0a;
            }
          }
          .is-focus .el-input__inner,
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-input__inner:hover {
            border-color: #dcdfe6;
            // box-shadow: 0 0 0 2px rgba(255, 170, 10, 0.2);
          }
        }
      }
      .div_right {
        height: 30px;
        line-height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 16px;
        border: 1px solid rgba(204, 204, 204, 1);
        margin-top: 8px;
        padding: 0px 12px;
        cursor: pointer;
        span {
          color: rgba(102, 102, 102, 1) !important;
          font-size: 14px !important;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
        .lgIcon {
          width: 16px;
          height: 16px;
          display: inline-block;
          background: url("../../assets/pc/switch_pc.svg") no-repeat;
          background-size: 100%;
        }
      }
      .div_right:hover {
        background: rgba(240, 240, 240, 1);
      }
    }
  }
  .confirmOrderBox-center {
    width: 1100px;
    margin: 24px auto;
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;
    .topStatus {
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(226, 226, 226, 1);
      .top {
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .statusIcon {
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .statusText {
          font-size: 24px;
          line-height: 24px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          margin-left: 12px;
        }
        .div_right {
          line-height: 24px;
        }
      }
      .timeBox {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 36px;
        margin-top: 16px;
        span {
          font-weight: 600;
          color: rgba(255, 121, 40, 1);
        }
      }
    }
    .botGoods {
      padding-top: 24px;
      .part {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 16px;
        .leftTitle {
          display: inline-block;
          line-height: 24px;
          margin-right: 24px;
          color: rgba(102, 102, 102, 1);
        }
        .rightInfo {
          color: rgba(51, 51, 51, 1);
          word-wrap: break-word;
          word-break: break-all;
          line-height: 24px;
        }
      }
    }
  }
  .confirmOrderBox-footer {
    padding: 40px;
    background: #fff;
    width: 1100px;
    margin: 0 auto;
    border-radius: 8px;
    margin-bottom: 100px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      margin-bottom: 24px;
    }
    .payWays {
      .part {
        width: 358px;
        height: 46px;
        padding: 16px 20px;
        border-radius: 8px;
        margin-bottom: 16px;
        border: 1px solid rgba(204, 204, 204, 1);
        cursor: pointer;
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .payIcon {
          width: 48px;
          height: 48px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .payPro {
          width: 294px;
          height: 48px;
          line-height: 48px;
          color: rgba(51, 51, 51, 1);
          margin-left: 16px;
          .van-cell {
            padding: 0 !important;
            height: 48px;
            font-size: 16px;
            font-weight: 400;
            background-color: rgba(0, 0, 0, 0);
          }
        }
      }
      .hoverPart:hover {
        border: 1px solid #ffaa0a !important;
      }
    }
    .payBtn {
      width: 220px;
      height: 40px;
      background: #ffaa0a;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      margin-top: 40px;
    }
    .payBtn:hover {
      background: #ec9d0a;
    }
    .resultIcon {
      width: 140px;
      height: 140px;
      margin: 20px auto 16px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .resultText {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      text-align: center;
      margin-bottom: 20px;
      span {
        color: #1082ff;
        cursor: pointer;
      }
    }
  }
}
</style>
